// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import DismissibleController from "./dismissible_controller"
application.register("dismissible", DismissibleController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import GoogleAnalyticsController from "./google_analytics_controller"
application.register("google-analytics", GoogleAnalyticsController)

import HoverCircleController from "./hover_circle_controller"
application.register("hover-circle", HoverCircleController)

import IssueSelectionController from "./issue_selection_controller"
application.register("issue-selection", IssueSelectionController)

import MessageCycleController from "./message_cycle_controller"
application.register("message-cycle", MessageCycleController)

import MoveIssuesController from "./move_issues_controller"
application.register("move-issues", MoveIssuesController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import PrioritiesToggleController from "./priorities_toggle_controller"
application.register("priorities-toggle", PrioritiesToggleController)

import ScrollController from "./scroll_controller"
application.register("scroll", ScrollController)

import TypewriterController from "./typewriter_controller"
application.register("typewriter", TypewriterController)
